// react and js
import { React, useMemo } from "react";
import { useTranslation } from "react-i18next";

// mui

// components
import Page from "../../components/Page";

// hooks

// layouts

// pages

// theme

// utils

// widgets
import WidgetNewPassword from "../../widgets/new_password/NewPassword";

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function NewPassword() {
  const { t } = useTranslation();

  // eslint-disable-next-line
  return useMemo(() => {
    return (
      <Page title={t("pages.new_password.title")}>
        <WidgetNewPassword />
      </Page>
    );
  }, [t]);
}
